import React from 'react';
import Button from '@mui/material/Button';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

import { calendarDays } from '../../utils/calendar';
import {
  getChoghadiyaData,
  getLabelArr,
  goodAuspiciousChoghadiya,
} from '../../utils/helper';
import {
  choghadiyaLines,
  getCountryFlagEmoji,
} from '../../utils/social-media-helper';
import { Locality } from '../Choghadiya';

import './Share.scss';
import { ChoghadiyaNames } from '../../utils/choghadiya-table';

type ShareProps = {
  className?: string;
  date: string;
  isNightChecked: boolean;
  locality: Locality | undefined;
  originalCity: string;
  timingsArr: string[];
  today: string;
  tithi: string | undefined;
};

const Share = ({
  className,
  date,
  locality,
  isNightChecked,
  originalCity,
  timingsArr,
  today,
  tithi,
}: ShareProps) => {
  const encodeURL = (url: string) => {
    return encodeURIComponent(url);
  };

  // Choose a random line from the additionalLines array
  const randomIndex = Math.floor(Math.random() * choghadiyaLines.length);
  const randomLine = choghadiyaLines[randomIndex];

  const getWhatsappText = () => {
    const dayTimeIcon = '🌞';
    const nightTimeIcon = '🌕';
    const labelArr =
      getLabelArr(isNightChecked, new Date(today).getDay()) || [];
    const choghadiyaData = getChoghadiyaData(labelArr, timingsArr);

    // Function to determine if a Choghadiya is good or bad.
    const isGoodChoghadiya = (label: ChoghadiyaNames) =>
      goodAuspiciousChoghadiya.includes(label);

    const formattedChoghadiyaData = choghadiyaData
      .map((row) => {
        const timing = timingsArr.length > 0 ? row.value : '-';
        const icon = isGoodChoghadiya(row.label) ? '✅' : '❌';
        return `${icon} ${row.label}: ${timing}`;
      })
      .join('\n');

    const shareMessage = `🕉️🙏 ${
      isNightChecked ? nightTimeIcon + ' Night Time' : dayTimeIcon + ' Day Time'
    } Choghadiya in ${originalCity} 📲

Pranam! Sharing auspicious ${
      isNightChecked ? nightTimeIcon + ' Night Time' : dayTimeIcon + ' Day Time'
    } Choghadiya timings in ${locality?.city}, ${locality?.region}, ${locality?.country}. ${getCountryFlagEmoji(
      locality?.country,
    )}✨

Date: ${today}
${tithi ? `Tithi: ${calendarDays.get(date)?.tithi}` : ''}

${formattedChoghadiyaData}

${randomLine}`;

    return shareMessage;
  };

  const whatsappShareLink = `https://api.whatsapp.com/send?text=${encodeURL(
    getWhatsappText(),
  )}`;

  return (
    <div className="share">
      <Button
        className={`whatsapp-button ${className}`}
        variant="contained"
        startIcon={<WhatsAppIcon />}
        href={whatsappShareLink}
        target="_blank"
        rel="noopener"
      >
        Share
      </Button>
    </div>
  );
};

export default Share;
